import React from 'react';

interface GitRepoListContainerProps {
  children: React.ReactNode;
  footnote?: string;
}

const GitRepoListContainer = ({
  children,
  footnote,
}: GitRepoListContainerProps) => (
  <>
    <div className="checkbox-list">{children}</div>
    <div className="checkbox-list-note">{footnote}</div>
  </>
);

export default GitRepoListContainer;
